import React from 'react';
import { Link } from 'react-router-dom';

const TermsPage: React.FC = () => (
  <div className="max-w-3xl mx-auto px-4 py-12">
    <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">Terms and Conditions</h1>
    <p className="text-gray-600 dark:text-gray-400 mb-4 leading-relaxed">
      By using CafeLawn, you agree to our terms of service. This page will be updated with full legal
      terms. For questions, contact{' '}
      <a href="mailto:support@cafelawn.com" className="text-purple-600 hover:underline">
        support@cafelawn.com
      </a>
      .
    </p>
    <Link to="/signup" className="text-purple-600 hover:underline text-sm font-medium">
      ← Back to signup
    </Link>
  </div>
);

export default TermsPage;
